import { render } from "./HomeTestimonials.vue?vue&type=template&id=11da9f74&scoped=true"
import script from "./HomeTestimonials.vue?vue&type=script&lang=js"
export * from "./HomeTestimonials.vue?vue&type=script&lang=js"

import "./HomeTestimonials.vue?vue&type=style&index=0&id=11da9f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11da9f74"]])

export default __exports__